module.exports = __webpack_public_path__ + "img/cx.1101c4c9.svg";